export default window.jQuery;
